(ns app.front.dashboard.property-management
  (:require [app.front.dashboard.common :as dashboard-common]
            [core.front.href :as href]))

(defn property-management-dashlet [tr]
  [:section.dashlet
   [:h2 (tr [:group.feature/property-management])]
   [dashboard-common/link-box-with-number
    {:title    (tr [:property/search-property-header])
     :href     (href/href :view/property-dashboard)
     :loading? false}]])
